import REQUEST_STATUS from './REQUEST_STATUS'

export const asyncPendingReducer = (state) => {
  state.context.appDataRequestStatus = REQUEST_STATUS.IN_PROGRESS
}

export const asyncRejectedReducer = (state, action) => {
  state.context.appDataRequestStatus = REQUEST_STATUS.FAILED
  state.error = action.error.message
}